import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers: [MessageService],
})
export class RegisterComponent implements OnInit {
  errorMessage: string = '';
  receivedEmail: string = '';
  receivedFirstName: string = '';
  receivedLastName: string = '';
  receivedCompanyAddress: string = '';
  receivedPhoneNumber: string = '';
  receivedPassword: string = '';
  receivedConfirmPassword: string = '';
  receivedCompanyName: string = '';
  registerSuccess: boolean = false;
  isLoading: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {}

  signin() {
    this.router.navigate(['signin']);
  }

  email(data: string) {
    this.receivedEmail = data;
  }
  firstName(data: string) {
    this.receivedFirstName = data;
  }
  lastName(data: string) {
    this.receivedLastName = data;
  }
  companyAddress(data: string) {
    this.receivedCompanyAddress = data;
  }
  companyName(data: string) {
    this.receivedCompanyName = data;
  }
  phoneNumber(data: string) {
    this.receivedPhoneNumber = data;
  }
  password(data: string) {
    this.receivedPassword = data;
  }
  confirmPassword(data: string) {
    this.receivedConfirmPassword = data;
  }

  register = () => {
    this.isLoading = true;
    if (this.receivedPassword !== this.receivedConfirmPassword) {
      this.errorMessage = 'Passwords must match!';
      return;
    }
    if (
      [
        this.receivedEmail,
        this.receivedPassword,
        this.receivedCompanyAddress,
        this.receivedCompanyName,
        this.receivedLastName,
        this.receivedLastName,
        this.receivedPhoneNumber,
      ].includes('')
    ) {
      this.errorMessage = 'All fields are required.';
      this.isLoading = false;
    }
    const newUser = {
      companyName: this.receivedCompanyName,
      companyAddress: this.receivedCompanyAddress,
      phoneNumber: this.receivedPhoneNumber,
      emailAddress: this.receivedEmail,
      password: this.receivedPassword,
      firstName: this.receivedFirstName,
      lastName: this.receivedLastName,
    };
    // console.log(this.receivedEmail);
    this.errorMessage = '';
    const isValid = this.authService.validateEmail(this.receivedEmail);
    if (!isValid) {
      this.errorMessage = 'Please use a correct email';
    }
    this.authService.register(newUser).subscribe(
      (res: any) => {
        if (res.statusCode === 200) {
          this.registerSuccess = true;
          // console.log('User successfully registered');
          this.router.navigate(['signin']);
          // setTimeout(() => {
          //   this.isLoading = false;
          // }, 2000);
        } else {
          this.isLoading = false;
          this.errorMessage = res.message;
        }
      },
      (error) => {
        // console.log(error);
        this.isLoading = false;
        this.errorMessage = error.error.message;
      }
    );
  };
}
